import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeTableOfContentsSetting'
 * @name TypeTableOfContentsSettingFields
 * @type {TypeTableOfContentsSettingFields}
 * @memberof TypeTableOfContentsSetting
 */
export interface TypeTableOfContentsSettingFields {
    /**
     * Field type definition for field 'exclude' (exclude)
     * @name exclude
     * @localized false
     */
    exclude?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'header' (header)
     * @name header
     * @localized false
     */
    header?: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'tableOfContentsSetting' (Table of Contents Setting)
 * @name TypeTableOfContentsSettingSkeleton
 * @type {TypeTableOfContentsSettingSkeleton}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-10-08T13:47:44.350Z
 * @version 1
 */
export type TypeTableOfContentsSettingSkeleton = EntrySkeletonType<TypeTableOfContentsSettingFields, "tableOfContentsSetting">;
/**
 * Entry type definition for content type 'tableOfContentsSetting' (Table of Contents Setting)
 * @name TypeTableOfContentsSetting
 * @type {TypeTableOfContentsSetting}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-10-08T13:47:44.350Z
 * @version 1
 */
export type TypeTableOfContentsSetting<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeTableOfContentsSettingSkeleton, Modifiers, Locales>;

export function isTypeTableOfContentsSetting<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeTableOfContentsSetting<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'tableOfContentsSetting'
}
